import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import MainBtn from './MainBtn'
import ContactAvatar from './ContactAvatar'
import {CHAT_DEFAULT_SUBJECT} from './constants.js'


class NewGroupSubject extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      subject:"",
    }

    this.handleSubjectChange = this.handleSubjectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderMainBtn = this.renderMainBtn.bind(this);
  }

  render(){
    return(
      <div>
        <div className="new-group-subject relative-position">
          <input className="subject form-control" value={this.state.subject} 
            onChange={this.handleSubjectChange}
            type="text" placeholder={this.props.intl.formatMessage({id: "subject_placeholder"})}
            autoFocus autoComplete="off" />
            { this.renderMainBtn() }
        </div>
        <div className="new-group-subject-participants-list ">
          <div className="text-muted participants-title">
            { this.props.intl.formatMessage({ id: 'participants' })}
          </div> 
          {this.props.participants.map(
            (item) =>
              <ContactAvatar 
                contact={item}
                showName={true}
                key={item.id}
              />
          )}
        </div>
      </div>
    );
  }


  handleSubjectChange(e){
    this.setState({subject: e.target.value});
  }

  handleSubmit(){
    this.props.onSubmit(this.state.subject);
  }

  renderMainBtn(){
    if( this.state.subject.length > 0 && this.state.subject != CHAT_DEFAULT_SUBJECT ){
      return (<MainBtn onClick={this.handleSubmit} glyphicon="ok" />);
    }
    else{
      return "";
    }

  }

}

export default injectIntl(NewGroupSubject);